module.exports = __webpack_public_path__ + "static/media/bg-arms.40af7f03.jpg";